import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import Colors from "/styles/colors";
import classnames from "classnames";
import { StyledBadgeComponent } from "./badge-component.scss";
class BadgeComponent extends PureComponent {
    render() {
        const { translate, badgeText, badgeColorName, badgeTextColorName, badgeStrokeColorName } = this.props;
        return /*#__PURE__*/ _jsx(StyledBadgeComponent, {
            className: classnames("core-badge-component", {
                "has-stroke": badgeStrokeColorName
            }),
            style: {
                backgroundColor: Colors[badgeColorName],
                color: Colors[badgeTextColorName],
                border: badgeStrokeColorName ? `1px solid ${Colors[badgeStrokeColorName]}` : "unset"
            },
            children: badgeText || translate("header.menuItem.popular")
        });
    }
}
export default withGenericConfig(BadgeComponent);
